import { render, staticRenderFns } from "./PaymentSection.vue?vue&type=template&id=b3c34152&scoped=true&"
import script from "./PaymentSection.vue?vue&type=script&lang=js&"
export * from "./PaymentSection.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSection.vue?vue&type=style&index=0&id=b3c34152&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c34152",
  null
  
)

export default component.exports